module.exports = __webpack_public_path__ + "img/武汉市爱之家汽车服务有限公司.b82f5220.png";